export default __webpack_public_path__ + "static/media/Druva-Footer-Logo.4161a67d.svg";